'use client';

import ErrorPage from '@commons/components/Page/Error';

/**
 * Using the reusable ErrorPage component.
 */

export default ErrorPage;
